import React, { useState } from "react";
import { XCircleIcon } from "@heroicons/react/solid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Modal } from "../../components";

const ExportModal = (props) => {
  const [checked, setChecked] = useState("allData");
  return (
    <Modal open={props.exportModal} onBackdropClick={props.onBackdropClick}>
      <div className="bg-white  border-3 border-[#FEBB13]">
        <div className="bg-[#007E8C] px-2 py-4 flex flow-row justify-between">
          <h3></h3>
          <h3 className="text-[#FFFFFF] ml-4 font-semibold ">Confirm Export</h3>
          <XCircleIcon
            onClick={props.handelNo}
            className="w-7 h-7 cursor-pointer "
            color="white"
          />
        </div>
        <div className="px-10 my-6">
          <p className="text-center text-lg text-[#333333] font-medium">
            Are you sure you want to export the data of the selected candidates?
          </p>

          <div className="flex justify-center items-center mt-6">
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={checked}
                onChange={(e) => {
                  setChecked(e.target.value);
                }}
              >
                <FormControlLabel
                  value="allData"
                  control={<Radio />}
                  label="All Candidates"
                />
                 <FormControlLabel
                  value="completedCandidates"
                  control={<Radio />}
                  label="Completed Candidates"
                />
                <FormControlLabel
                  value="selectedCandidates"
                  control={<Radio />}
                  label="Selected Candidates"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
        <div className="absolute bottom-10 w-full flex flex-row justify-center">
          <button
            onClick={() => props.handelExportData(checked)}
            className="bg-[#FEBB12] text-[white] px-10 py-2 mx-2"
          >
            Yes
          </button>
          <button
            onClick={props.handelNo}
            className="bg-[#007E8C] text-[white] px-10 py-2 mx-2"
          >
            No
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ExportModal;
